import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../client';
import type { Notification } from '../types';

export const notificationKeys = {
  all: ['notifications'] as const,
};

export function useNotifications(enabled: boolean) {
  return useQuery({
    queryKey: notificationKeys.all,
    queryFn: () => api<{ notifications: Notification[] }>('/notifications'),
    select: (data) => data.notifications,
    enabled,
  });
}

export function useMarkNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<{ ok: true }>('/notifications/read', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
